module.exports = __webpack_public_path__ + "static/media/bell.9e8c2295.svg";